"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.typed.uint8-array");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_buffer_from_1 = require("@aws-sdk/util-buffer-from");

function fromUtf8(input) {
  var buf = util_buffer_from_1.fromString(input, 'utf8');
  return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength / Uint8Array.BYTES_PER_ELEMENT);
}

exports.fromUtf8 = fromUtf8;

function toUtf8(input) {
  return util_buffer_from_1.fromArrayBuffer(input.buffer, input.byteOffset, input.byteLength).toString('utf8');
}

exports.toUtf8 = toUtf8;